import * as React from 'react';

import moment from 'moment';

import {colors} from '../colors/colors';
import {Popover} from '../popover/popover';

import {StaticTwoLineWithIcon} from './static-two-line-with-icon';

import styles from './list-row-with-icon.module.css';

type Props = {
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    icon: React.ComponentType<any> | React.ReactNode;
    createdTime?: number;
    isDisabled?: boolean;
    disabledPopoverText?: string;
    disabledSubtitleText?: string;
};

export function ListRowWithIcon(props: Props) {
    const {
        title,
        subtitle,
        icon,
        createdTime,
        isDisabled,
        disabledPopoverText,
        disabledSubtitleText,
    } = props;

    const [shouldShowPopover, setShouldShowPopover] = React.useState<boolean>(false);
    const popoverAnchor = React.useRef(undefined);
    const Icon = icon && typeof icon === 'function' ? icon : undefined;
    const iconComponent = icon && typeof icon === 'object' ? icon : undefined;

    return (
        <>
            <div
                onMouseEnter={
                    isDisabled && disabledPopoverText
                        ? () => {
                              setShouldShowPopover(true);
                          }
                        : undefined
                }
                onMouseLeave={
                    isDisabled && disabledPopoverText
                        ? () => {
                              setShouldShowPopover(false);
                          }
                        : undefined
                }
                ref={(c) => {
                    // @ts-expect-error
                    popoverAnchor.current = c;
                }}
                className={isDisabled ? styles['row-container--disabled'] : styles['row-container']}
            >
                {subtitle ? (
                    <StaticTwoLineWithIcon
                        title={title}
                        subtitle={subtitle}
                        icon={icon}
                        isDisabled={isDisabled}
                        disabledSubtitleText={disabledSubtitleText}
                    />
                ) : (
                    <div className='flex align-center'>
                        <div className={styles.icon}>
                            {Icon ? (
                                <Icon
                                    wrapWithDiv={false}
                                    fill={isDisabled ? colors.greyLt : undefined}
                                    height={14}
                                    size={14}
                                />
                            ) : undefined}
                            {iconComponent ? iconComponent : undefined}
                        </div>
                        <div className={styles.title}>{title}</div>
                    </div>
                )}
                {createdTime ? (
                    <div className={styles['created-time']}>
                        {moment.unix(createdTime).fromNow()}
                    </div>
                ) : undefined}
            </div>
            {popoverAnchor.current && shouldShowPopover ? (
                <Popover anchor={popoverAnchor.current} isDialog={true}>
                    {disabledPopoverText}
                </Popover>
            ) : undefined}
        </>
    );
}
